import { Button as PrimeButton } from "primereact/button";

interface IButtonProps {
    icon?: React.ReactNode;
    type?: "button"|"submit";
    className?: string;
    disabled?: boolean;
    loading?: boolean;
    onClick: () => void;
    children?: React.ReactNode;
}

export default function Button({ icon, type = "button", disabled, loading, className, onClick, children }: IButtonProps) {
    return (
        <>
            {
                children
                    ? (
                        <PrimeButton 
                            icon={icon}
                            type={type}
                            disabled={disabled || loading}
                            loading={loading}
                            className={`${className} flex gap-2`}
                            onClick={onClick}
                        >
                            {children}
                        </PrimeButton>
                    )
                    : (
                        <PrimeButton 
                            icon={icon}
                            type={type}
                            disabled={disabled || loading}
                            loading={loading}
                            className={`${className} flex gap-2`}
                            onClick={onClick}
                        />
                    )
            }
        </>
    )
}